/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const FeesIcon = ({ width, height }) => {
  return (
    <svg
      className="animated"
      id="freepik_stories-finance"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 750 500"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            'svg#freepik_stories-finance:not(.animated) .animable {opacity: 0;}svg#freepik_stories-finance.animated #freepik--background-complete--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-finance.animated #freepik--Floor--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-finance.animated #freepik--Device--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-finance.animated #freepik--money-box--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-finance.animated #freepik--Character--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-finance.animated #freepik--speech-bubble--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}            @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        .animator-hidden { display: none; }',
        }}
      />
      <g
        id="freepik--background-complete--inject-7"
        style={{ transformOrigin: '351.45741271972656px 149.3153896331787px' }}
        className="animable"
      >
        <path
          d="M605.37,94.68a24,24,0,1,1-27.18-20.24A24,24,0,0,1,605.37,94.68Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '581.6282424926758px 98.1909122467041px',
          }}
          id="el8vcn71lbcj4"
          className="animable"
        />
        <path
          d="M599.73,95.5A18.29,18.29,0,1,1,579,80.08,18.27,18.27,0,0,1,599.73,95.5Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '581.6372222900391px 98.17753410339355px',
          }}
          id="elvk22n6zeyua"
          className="animable"
        />
        <path
          d="M599.64,94.93a11,11,0,0,1-.8-2.1,18.76,18.76,0,0,0-5.76-8.19,18.13,18.13,0,0,0-4-2.46,16.44,16.44,0,0,0-2.38-.89,18,18,0,0,0-2.59-.55,18.89,18.89,0,0,0-2.73-.16,20.73,20.73,0,0,0-2.81.28,18.85,18.85,0,0,0-2.73.71,16.66,16.66,0,0,0-2.52,1.09,17,17,0,0,0-2.24,1.41,16.2,16.2,0,0,0-1.93,1.64,18.19,18.19,0,0,0-2.9,3.7,18.86,18.86,0,0,0-1.69,3.75,19.59,19.59,0,0,0-.91,5.91,10.72,10.72,0,0,1,0,2.25,5.34,5.34,0,0,1-.52-2.22,17,17,0,0,1,.5-6.22,18.55,18.55,0,0,1,4.62-8.08,18,18,0,0,1,2-1.8,18.36,18.36,0,0,1,5.1-2.75,21.87,21.87,0,0,1,2.94-.77,21,21,0,0,1,3-.29,17.91,17.91,0,0,1,2.95.2,16.89,16.89,0,0,1,2.79.63,17.17,17.17,0,0,1,2.54,1,18.49,18.49,0,0,1,4.2,2.75A18.79,18.79,0,0,1,596.75,87a17,17,0,0,1,2.62,5.67A5.41,5.41,0,0,1,599.64,94.93Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '581.3504180908203px 90.25399112701416px',
          }}
          id="el5qdzuzvpusf"
          className="animable"
        />
        <path
          d="M585.25,108.62l.5,3.15-2.81.45-.49-3.06A13.55,13.55,0,0,1,575.1,108l1-3.67a11.49,11.49,0,0,0,5.76,1.12l-.75-4.69c-3.24-.26-6.88-.74-7.53-4.76-.47-3,1.28-5.87,5.63-7.09l-.49-3.12,2.8-.45.49,3.07a12.8,12.8,0,0,1,6,.8l-.85,3.67a11.87,11.87,0,0,0-4.53-.77l.76,4.78c3.24.23,6.83.72,7.46,4.68C591.3,104.52,589.57,107.39,585.25,108.62Zm-4.8-12-.64-4c-1.43.57-1.89,1.48-1.74,2.41S579.15,96.47,580.45,96.66Zm5.91,6c-.15-1-1.05-1.39-2.33-1.62l.62,3.88C586,104.38,586.51,103.56,586.36,102.66Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '582.2125091552734px 98.78000259399414px',
          }}
          id="el7r909q2kzuj"
          className="animable"
        />
        <path
          d="M530.61,98.93A41.65,41.65,0,1,1,483.42,63.8,41.6,41.6,0,0,1,530.61,98.93Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '489.4072723388672px 105.01409530639648px',
          }}
          id="el55bdk7owdvt"
          className="animable"
        />
        <path
          d="M520.8,100.35a31.74,31.74,0,1,1-36-26.77A31.7,31.7,0,0,1,520.8,100.35Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '489.4002056121826px 104.98421859741211px',
          }}
          id="elnf3fx72ztx"
          className="animable"
        />
        <path
          d="M520.65,99.37c-.19,0-.52-1.32-1.38-3.66a33.82,33.82,0,0,0-5-9.1,32.65,32.65,0,0,0-5-5.1,32.11,32.11,0,0,0-6.93-4.29,29.91,29.91,0,0,0-4.14-1.53,29.54,29.54,0,0,0-4.49-1,31.09,31.09,0,0,0-4.75-.28,30.69,30.69,0,0,0-9.62,1.71A29.88,29.88,0,0,0,475,78.06a30.44,30.44,0,0,0-3.89,2.44,31.4,31.4,0,0,0-3.36,2.86,31.8,31.8,0,0,0-5,6.42,33,33,0,0,0-2.93,6.51,34,34,0,0,0-1.58,10.27c0,2.48.16,3.87,0,3.9s-.61-1.31-.91-3.85a29.39,29.39,0,0,1,.87-10.81,31.84,31.84,0,0,1,8-14,29.15,29.15,0,0,1,3.55-3.14A32,32,0,0,1,473.84,76a31,31,0,0,1,4.7-2.08,35.49,35.49,0,0,1,5.11-1.35,34.89,34.89,0,0,1,5.26-.49,32,32,0,0,1,5.12.33,31.41,31.41,0,0,1,4.83,1.09,31.8,31.8,0,0,1,4.41,1.72,32.46,32.46,0,0,1,7.3,4.78,32.08,32.08,0,0,1,5.06,5.62,29.31,29.31,0,0,1,4.55,9.84C520.78,97.93,520.79,99.35,520.65,99.37Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '488.94565200805664px 91.26822662353516px',
          }}
          id="el3zers6p9u5y"
          className="animable"
        />
        <path
          d="M495.67,123.14l.87,5.46-4.87.77-.85-5.31c-4.87.48-9.75-.29-12.76-2l1.72-6.38a20,20,0,0,0,10,2l-1.31-8.14c-5.62-.45-11.95-1.29-13.07-8.26-.82-5.17,2.22-10.2,9.78-12.31l-.87-5.41,4.88-.78.85,5.31a22.34,22.34,0,0,1,10.37,1.39L499,95.87a20.26,20.26,0,0,0-7.86-1.35l1.32,8.29c5.62.4,11.85,1.25,12.95,8.12C506.17,116,503.17,121,495.67,123.14Zm-8.33-20.77-1.1-6.92c-2.49,1-3.29,2.58-3,4.19S485.09,102,487.34,102.37Zm10.27,10.41c-.27-1.71-1.84-2.41-4.05-2.81l1.08,6.73C497,115.78,497.86,114.34,497.61,112.78Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '490.3972930908203px 106.07501220703125px',
          }}
          id="elow0oprq0qc"
          className="animable"
        />
        <path
          d="M162.37,240.76a24,24,0,1,1-27.19-20.23A24,24,0,0,1,162.37,240.76Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '138.62968254089355px 244.2808380126953px',
          }}
          id="eliqmouq95glb"
          className="animable"
        />
        <path
          d="M156.72,241.58A18.29,18.29,0,1,1,136,226.16,18.28,18.28,0,0,1,156.72,241.58Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '138.62747383117676px 244.25964546203613px',
          }}
          id="elwouqjbctd3p"
          className="animable"
        />
        <path
          d="M156.63,241a10.61,10.61,0,0,1-.79-2.11,19.42,19.42,0,0,0-2.9-5.24,18.8,18.8,0,0,0-2.87-2.94,18.16,18.16,0,0,0-4-2.47,16,16,0,0,0-2.38-.88,16.52,16.52,0,0,0-2.59-.55,17.57,17.57,0,0,0-2.73-.16,19.22,19.22,0,0,0-2.81.27,17.76,17.76,0,0,0-7.49,3.21,17.26,17.26,0,0,0-1.93,1.65,18.14,18.14,0,0,0-2.9,3.69,19.12,19.12,0,0,0-1.69,3.75,19.61,19.61,0,0,0-.91,5.92,10,10,0,0,1,0,2.25,5.41,5.41,0,0,1-.52-2.22,17,17,0,0,1,.5-6.23,18.49,18.49,0,0,1,1.63-4,19,19,0,0,1,3-4,17,17,0,0,1,2-1.81,19.08,19.08,0,0,1,5.1-2.74,20.28,20.28,0,0,1,2.95-.78,20.69,20.69,0,0,1,3-.28,19.16,19.16,0,0,1,3,.19,17.84,17.84,0,0,1,2.78.63,18.35,18.35,0,0,1,2.54,1,18.26,18.26,0,0,1,7.12,6,17,17,0,0,1,2.62,5.67A5.46,5.46,0,0,1,156.63,241Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '138.33697319030762px 236.35887050628662px',
          }}
          id="el2p1g80d3wlm"
          className="animable"
        />
        <path
          d="M142.24,254.71l.5,3.14-2.81.45-.49-3.06a13.46,13.46,0,0,1-7.35-1.12l1-3.68a11.4,11.4,0,0,0,5.77,1.12l-.76-4.69c-3.23-.25-6.88-.73-7.52-4.75-.48-3,1.27-5.88,5.63-7.09l-.5-3.12,2.81-.45.49,3.06a12.77,12.77,0,0,1,6,.8l-.85,3.68a11.47,11.47,0,0,0-4.53-.77l.76,4.77c3.24.23,6.83.72,7.46,4.68C148.29,250.6,146.56,253.47,142.24,254.71Zm-4.8-12-.64-4c-1.43.58-1.89,1.48-1.74,2.41S136.14,242.55,137.44,242.75Zm5.92,6c-.16-1-1.06-1.38-2.34-1.61l.62,3.87C143,250.47,143.5,249.64,143.36,248.74Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '139.20972633361816px 244.8800277709961px',
          }}
          id="eloag0oluhsab"
          className="animable"
        />
        <path
          d="M121.26,187.94a15.61,15.61,0,1,1,4.84-21.51A15.59,15.59,0,0,1,121.26,187.94Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '112.90142345428467px 174.7588300704956px',
          }}
          id="elvidv1ggmeu"
          className="animable"
        />
        <path
          d="M119.27,184.8a11.9,11.9,0,1,1,3.7-16.4A11.89,11.89,0,0,1,119.27,184.8Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '112.9053602218628px 174.7462682723999px',
          }}
          id="elux846aw1hgr"
          className="animable"
        />
        <path
          d="M119.59,184.6c0-.06.37-.38,1-1a12.48,12.48,0,0,0,2.35-3.11,11.7,11.7,0,0,0,1.4-5.51,10.29,10.29,0,0,0-.1-1.65,11.2,11.2,0,0,0-.36-1.68,11.65,11.65,0,0,0-.63-1.67,11.4,11.4,0,0,0-2.05-3,10.59,10.59,0,0,0-1.31-1.2,10.83,10.83,0,0,0-1.43-1A10.19,10.19,0,0,0,117,164a12,12,0,0,0-3-.75,13.25,13.25,0,0,0-2.67,0,12.46,12.46,0,0,0-3.76,1,7.49,7.49,0,0,1-1.35.58s.36-.41,1.19-.9a10.94,10.94,0,0,1,3.83-1.34,11.85,11.85,0,0,1,2.83-.11,12,12,0,0,1,3.19.72,11.13,11.13,0,0,1,1.62.74,11.41,11.41,0,0,1,1.55,1,12.32,12.32,0,0,1,2.66,2.84,12.89,12.89,0,0,1,1,1.73,12.67,12.67,0,0,1,.67,1.8,12,12,0,0,1,.36,1.82,10.71,10.71,0,0,1,.08,1.78,12.12,12.12,0,0,1-.52,3.22,11.91,11.91,0,0,1-1.16,2.59,11,11,0,0,1-2.68,3.06A3.63,3.63,0,0,1,119.59,184.6Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '115.71395301818848px 173.52060890197754px',
          }}
          id="eln7tq76iukoi"
          className="animable"
        />
        <path
          d="M107.65,179.66l-1.74,1.13-1-1.55,1.69-1.1a8.66,8.66,0,0,1-1.27-4.67l2.44-.38a7.48,7.48,0,0,0,.86,3.73l2.59-1.69c-.7-2-1.38-4.29.84-5.73,1.64-1.07,3.83-.8,5.7,1.47l1.72-1.12,1,1.55-1.69,1.1a8.4,8.4,0,0,1,1.11,3.76l-2.42.47a7.55,7.55,0,0,0-.73-2.9l-2.64,1.72c.72,2,1.38,4.25-.81,5.67C111.69,182.17,109.52,181.9,107.65,179.66Zm5.84-6,2.2-1.44c-.72-.7-1.38-.73-1.89-.4S113.26,172.82,113.49,173.65Zm-2,5.1c.54-.36.54-1,.34-1.82l-2.14,1.4C110.37,179,111,179.07,111.49,178.75Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '112.69500732421875px 175.25328016281128px',
          }}
          id="elp713vt0381j"
          className="animable"
        />
        <path
          d="M540,59.14a15.61,15.61,0,1,1,4.84-21.51A15.58,15.58,0,0,1,540,59.14Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '531.6423358917236px 45.958800315856934px',
          }}
          id="elazubnumpkmv"
          className="animable"
        />
        <path
          d="M538,56a11.9,11.9,0,1,1,3.69-16.39A11.88,11.88,0,0,1,538,56Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '531.6261072158813px 45.95344066619873px',
          }}
          id="elcijgrvklya4"
          className="animable"
        />
        <path
          d="M538.3,55.8c0-.06.37-.38,1-1a12.48,12.48,0,0,0,2.35-3.11,11.45,11.45,0,0,0,1-2.48,12.11,12.11,0,0,0,.42-3A11.63,11.63,0,0,0,543,44.5a11.2,11.2,0,0,0-.36-1.68,11,11,0,0,0-.63-1.67,12.08,12.08,0,0,0-.9-1.6A12.33,12.33,0,0,0,540,38.12a10.69,10.69,0,0,0-1.32-1.21,10.21,10.21,0,0,0-1.43-1,11.32,11.32,0,0,0-1.49-.72,11.57,11.57,0,0,0-3-.74,11.93,11.93,0,0,0-2.67,0,12.49,12.49,0,0,0-3.76,1,6.67,6.67,0,0,1-1.35.58s.36-.41,1.19-.9A10.94,10.94,0,0,1,530,33.84a11.38,11.38,0,0,1,2.83-.1,11.94,11.94,0,0,1,3.19.71,11.13,11.13,0,0,1,1.62.74,12.45,12.45,0,0,1,3,2.31A12.4,12.4,0,0,1,541.85,39a13,13,0,0,1,1,1.73,12.61,12.61,0,0,1,.66,1.8,10.85,10.85,0,0,1,.36,1.82,10.71,10.71,0,0,1,.08,1.78,12.12,12.12,0,0,1-.52,3.22A11.91,11.91,0,0,1,542.25,52,11,11,0,0,1,539.58,55,3.71,3.71,0,0,1,538.3,55.8Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '534.4689235687256px 44.74727535247803px',
          }}
          id="el81dfm4618s"
          className="animable"
        />
        <path
          d="M526.36,50.86,524.62,52l-1-1.55,1.69-1.1A8.75,8.75,0,0,1,524,44.67l2.44-.38a7.58,7.58,0,0,0,.86,3.73l2.59-1.69c-.7-2-1.38-4.29.84-5.73,1.64-1.07,3.83-.8,5.7,1.47L538.19,41l1,1.55-1.69,1.1a8.42,8.42,0,0,1,1.1,3.77l-2.41.46a7.64,7.64,0,0,0-.74-2.89l-2.64,1.71c.72,2,1.38,4.25-.81,5.67C530.4,53.37,528.24,53.1,526.36,50.86Zm5.84-6,2.2-1.43c-.72-.71-1.38-.74-1.89-.41S532,44,532.2,44.85Zm-2,5.1c.54-.36.54-1,.34-1.81l-2.14,1.39C529.08,50.19,529.7,50.27,530.2,50Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '531.4049987792969px 46.45978593826294px',
          }}
          id="el5iwp10dqmhg"
          className="animable"
        />
      </g>
      <g
        id="freepik--Floor--inject-7"
        style={{ transformOrigin: '375.0000305175781px 470.3599853515625px' }}
        className="animable"
      >
        <path
          d="M710.26,470.36c0,.14-150.11.26-335.24.26s-335.28-.12-335.28-.26,150.08-.26,335.28-.26S710.26,470.21,710.26,470.36Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '375.0000305175781px 470.3599853515625px',
          }}
          id="elskg4vrq67f"
          className="animable"
        />
      </g>
      <g
        id="freepik--Device--inject-7"
        style={{ transformOrigin: '439.6800079345703px 268.70499420166016px' }}
        className="animable"
      >
        <path
          d="M669,134.64H288.28a11.88,11.88,0,0,0-11.88,11.89V415.44a11.88,11.88,0,0,0,11.88,11.88H434.4s9.3,28.74-19.52,43.62H551.51S519,459.78,527.34,427.32H669a11.88,11.88,0,0,0,11.88-11.88V146.53A11.88,11.88,0,0,0,669,134.64Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '478.6399841308594px 302.7899932861328px',
          }}
          id="elj8wedxvrupq"
          className="animable"
        />
        <path
          d="M483.72,399c5.18,7.4-2.92,15.51-10.33,10.33a2.56,2.56,0,0,1-.63-.64c-5.17-7.4,2.93-15.49,10.33-10.32A2.69,2.69,0,0,1,483.72,399Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '478.2425584793091px 403.85138463974px',
          }}
          id="elnkcaggf3nqk"
          className="animable"
        />
        <path
          d="M292.65,139.57h372a9.7,9.7,0,0,1,9.7,9.7V378.13a0,0,0,0,1,0,0H283a0,0,0,0,1,0,0V149.27A9.7,9.7,0,0,1,292.65,139.57Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '478.6750183105469px 258.8500061035156px',
          }}
          id="elhwrn2rqeb7i"
          className="animable"
        />
        <rect
          x="316.11"
          y="193.42"
          width="12.84"
          height="143.36"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '322.53000000000003px 265.1px',
          }}
          id="elr51a38wxzy"
          className="animable"
        />
        <rect
          x="340.89"
          y="242.11"
          width="12.84"
          height="94.67"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '347.31px 289.445px',
          }}
          id="el8xlbp6wbi9q"
          className="animable"
        />
        <rect
          x="365.67"
          y="211.24"
          width="12.84"
          height="126.27"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '372.09000000000003px 274.375px',
          }}
          id="elvxru1kklni"
          className="animable"
        />
        <rect
          x="390.46"
          y="198.96"
          width="12.84"
          height="137.82"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '396.88px 267.87px',
          }}
          id="elrk13z4fi96d"
          className="animable"
        />
        <rect
          x="415.24"
          y="245.03"
          width="12.84"
          height="91.75"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '421.66px 290.905px',
          }}
          id="elftnnayxt50w"
          className="animable"
        />
        <rect
          x="440.02"
          y="263.02"
          width="12.84"
          height="73.76"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '446.44px 299.9px',
          }}
          id="eldnyvy6hzog"
          className="animable"
        />
        <rect
          x="464.8"
          y="208.14"
          width="12.84"
          height="128.64"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '471.22px 272.46px',
          }}
          id="elbvm3mohy3o"
          className="animable"
        />
        <rect
          x="489.58"
          y="231.33"
          width="12.84"
          height="105.45"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '496px 284.055px',
          }}
          id="elx5q95l92zud"
          className="animable"
        />
        <rect
          x="514.37"
          y="212.8"
          width="12.84"
          height="123.98"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '520.79px 274.79px',
          }}
          id="elgvqjqkedh98"
          className="animable"
        />
        <rect
          x="539.15"
          y="252.31"
          width="12.84"
          height="84.47"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '545.5699999999999px 294.545px',
          }}
          id="ela5xfiilnr1p"
          className="animable"
        />
        <rect
          x="588.58"
          y="208.14"
          width="12.84"
          height="128.64"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '595px 272.46px',
          }}
          id="el4wstlega28h"
          className="animable"
        />
        <rect
          x="641.21"
          y="290.91"
          width="12.84"
          height="44.02"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '647.63px 312.92px',
          }}
          id="elg2uu15ta6if"
          className="animable"
        />
        <rect
          x="615.55"
          y="252.31"
          width="12.84"
          height="84.47"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '621.9699999999999px 294.545px',
          }}
          id="elmygm7ie3hpc"
          className="animable"
        />
        <rect
          x="563.93"
          y="236.24"
          width="12.84"
          height="100.54"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '570.3499999999999px 286.51px',
          }}
          id="elot2frclqky"
          className="animable"
        />
        <path
          d="M657.65,211.7a8,8,0,0,1-1.12-.18l-3.27-.67a51.13,51.13,0,0,0-5.34-.85,66,66,0,0,0-7.35-.61,85.11,85.11,0,0,0-20.1,1.72,88.72,88.72,0,0,0-24.92,9.44,101.73,101.73,0,0,0-25.25,20.1c-7.86,8.62-14.49,19.27-21.27,30.54S535.21,294.56,525.12,305a62.58,62.58,0,0,1-17.61,13.17,36.7,36.7,0,0,1-10.86,3.32,34.8,34.8,0,0,1-11.51-.39c-7.62-1.68-14.37-5.68-20.05-10.51a93.34,93.34,0,0,1-14.85-16.21c-8.62-11.6-14.74-24.1-21.29-35.49s-13.12-22.11-21.27-30.46a57.85,57.85,0,0,0-13.15-10.34,55.32,55.32,0,0,0-7.11-3.45,57.84,57.84,0,0,0-7.25-2.15,52.75,52.75,0,0,0-26.35.74,59.44,59.44,0,0,0-18.09,8.7,65.88,65.88,0,0,0-9.5,8.52L324,232.92a7,7,0,0,1-.8.82,5.72,5.72,0,0,1,.68-.91l2.11-2.6a61.8,61.8,0,0,1,9.39-8.77,59,59,0,0,1,18.2-9,53.25,53.25,0,0,1,26.79-1c9.87,2,19.93,7.64,28.14,16.1s15.05,19.19,21.57,30.63,12.74,23.87,21.27,35.32a92.61,92.61,0,0,0,14.64,16c5.56,4.73,12.12,8.59,19.42,10.2a33.47,33.47,0,0,0,11,.37,35.66,35.66,0,0,0,10.45-3.19A61.34,61.34,0,0,0,524.11,304c9.95-10.23,16.91-22.31,23.79-33.5s13.52-22,21.52-30.66a102.84,102.84,0,0,1,25.63-20.18,88.53,88.53,0,0,1,25.26-9.33,83.23,83.23,0,0,1,20.28-1.5,61.83,61.83,0,0,1,7.39.75,45.15,45.15,0,0,1,5.34,1l3.24.81A7.13,7.13,0,0,1,657.65,211.7Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '490.4250183105469px 265.262996673584px',
          }}
          id="elvbnatovw4ph"
          className="animable"
        />
        <path
          d="M302,346.77c-.29,0-.53-40.88-.53-91.3s.24-91.3.53-91.3.53,40.87.53,91.3S302.27,346.77,302,346.77Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '302px 255.46998596191406px',
          }}
          id="elmeapdxz9rrs"
          className="animable"
        />
        <path
          d="M654,346.77c0,.29-77,.52-172,.52s-172-.23-172-.52,77-.53,172-.53S654,346.48,654,346.77Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '482px 346.7649841308594px',
          }}
          id="elwmn0mfuc7fj"
          className="animable"
        />
        <path
          d="M334.42,358.05c0,.29-4.26.53-9.52.53s-9.53-.24-9.53-.53,4.26-.53,9.53-.53S334.42,357.76,334.42,358.05Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '324.89501953125px 358.04998779296875px',
          }}
          id="elbpjdrethdr8"
          className="animable"
        />
        <path
          d="M366,358.62c0,.3-5.1.53-11.38.53s-11.39-.23-11.39-.53,5.1-.52,11.39-.52S366,358.33,366,358.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '354.614990234375px 358.625px',
          }}
          id="elo8o5q3sz9d"
          className="animable"
        />
        <path
          d="M393,358.62c0,.3-5.1.53-11.38.53s-11.39-.23-11.39-.53,5.1-.52,11.39-.52S393,358.33,393,358.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '381.614990234375px 358.625px',
          }}
          id="el0zsicyvfwvds"
          className="animable"
        />
        <path
          d="M419.92,358.62c0,.3-5.1.53-11.38.53s-11.39-.23-11.39-.53,5.1-.52,11.39-.52S419.92,358.33,419.92,358.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '408.5350036621094px 358.625px',
          }}
          id="elsi1mdety8qc"
          className="animable"
        />
        <path
          d="M446.87,358.62c0,.3-5.09.53-11.38.53s-11.39-.23-11.39-.53,5.1-.52,11.39-.52S446.87,358.33,446.87,358.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '435.4849853515625px 358.625px',
          }}
          id="eltyi2l6pb4y"
          className="animable"
        />
        <path
          d="M473.83,358.62c0,.3-5.1.53-11.39.53s-11.38-.23-11.38-.53,5.09-.52,11.38-.52S473.83,358.33,473.83,358.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '462.4449768066406px 358.625px',
          }}
          id="el6r555a0cuce"
          className="animable"
        />
        <path
          d="M500.78,358.62c0,.3-5.1.53-11.39.53s-11.38-.23-11.38-.53,5.09-.52,11.38-.52S500.78,358.33,500.78,358.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '489.3949890136719px 358.625px',
          }}
          id="elsevvvqzcc99"
          className="animable"
        />
        <path
          d="M527.73,358.62c0,.3-5.1.53-11.39.53s-11.38-.23-11.38-.53,5.1-.52,11.38-.52S527.73,358.33,527.73,358.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '516.344970703125px 358.625px',
          }}
          id="elf42crdnl03"
          className="animable"
        />
        <path
          d="M554.68,358.62c0,.3-5.1.53-11.38.53s-11.39-.23-11.39-.53,5.1-.52,11.39-.52S554.68,358.33,554.68,358.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '543.2949829101562px 358.625px',
          }}
          id="el4n9rwm3nhhq"
          className="animable"
        />
        <path
          d="M581.63,358.62c0,.3-5.1.53-11.38.53s-11.39-.23-11.39-.53,5.1-.52,11.39-.52S581.63,358.33,581.63,358.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '570.2449951171875px 358.625px',
          }}
          id="el4xv2rge8udt"
          className="animable"
        />
        <path
          d="M606.7,358.63c0,.3-5.1.53-11.39.53s-11.38-.23-11.38-.53,5.1-.52,11.38-.52S606.7,358.34,606.7,358.63Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '595.3150024414062px 358.635009765625px',
          }}
          id="elteu8uj1uoek"
          className="animable"
        />
        <path
          d="M631.77,358.64c0,.29-5.1.53-11.39.53s-11.38-.24-11.38-.53,5.09-.52,11.38-.52S631.77,358.35,631.77,358.64Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '620.385009765625px 358.64501953125px',
          }}
          id="el963i5bs7ti5"
          className="animable"
        />
        <path
          d="M656.83,358.65c0,.29-5.1.53-11.38.53s-11.39-.24-11.39-.53,5.1-.53,11.39-.53S656.83,358.36,656.83,358.65Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '645.4450073242188px 358.6499938964844px',
          }}
          id="elp81mjc2ufc"
          className="animable"
        />
        <path
          d="M433,260.17c0-.22,1.58.33,2.08,2.48a5.28,5.28,0,0,1-.4,3.7,3.2,3.2,0,0,1-1.87,1.58,3.44,3.44,0,0,1-2.61-.31,4.37,4.37,0,0,1-2.23-4.09,4.58,4.58,0,0,1,1.79-3.31,2.93,2.93,0,0,1,2.45-.6c.6.18.8.47.76.53s-1.3-.4-2.56.85a3.77,3.77,0,0,0-1.12,2.58,3.18,3.18,0,0,0,1.59,2.78,1.9,1.9,0,0,0,2.66-.68,4.68,4.68,0,0,0,.54-2.85C433.91,261,432.89,260.34,433,260.17Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '431.6043436527252px 263.80846881866455px',
          }}
          id="el2pb14c8fkuy"
          className="animable"
        />
        <path
          d="M601.94,213c0-.08.41-.21,1.12,0a4.32,4.32,0,0,1,2.29,2,5.69,5.69,0,0,1,.56,4.5,4.73,4.73,0,0,1-4.39,3.51,3.74,3.74,0,0,1-2.79-1.45,6,6,0,0,1-1.18-2.5,5.7,5.7,0,0,1,.72-4.47c1.58-2.23,3.53-2.12,3.46-2,.09.21-1.54.52-2.59,2.47a5,5,0,0,0-.31,3.63c.34,1.32,1.36,2.83,2.74,2.84a3.53,3.53,0,0,0,3.09-2.49,4.92,4.92,0,0,0-.21-3.61A5.18,5.18,0,0,0,601.94,213Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '601.7578692436218px 217.77351331710815px',
          }}
          id="elxnwu0w0kxw"
          className="animable"
        />
        <rect
          x="198.68"
          y="66.81"
          width="257.61"
          height="200.49"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '327.485px 167.055px',
          }}
          id="elbgdgvz8tkca"
          className="animable"
        />
        <path
          d="M456.29,267.3c0-2-.09-79.5-.24-200.49l.24.24-257.58,0h0l.29-.29c0,72.27,0,140.62,0,200.49l-.26-.26,257.61.26-257.61.26h-.26v-.26c0-59.87,0-128.22,0-200.49v-.29h.32l257.58,0h.24v.24C456.39,187.8,456.3,265.3,456.29,267.3Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '327.5500030517578px 166.98999786376953px',
          }}
          id="elw4n1wi8iecd"
          className="animable"
        />
        <rect
          x="211.25"
          y="93.15"
          width="41.7"
          height="2.32"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '232.1px 94.31px',
          }}
          id="el5msf5n08b0c"
          className="animable"
        />
        <rect
          x="211.25"
          y="98.58"
          width="20.61"
          height="2.32"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '221.555px 99.74px',
          }}
          id="elfm59viahg1w"
          className="animable"
        />
        <rect
          x="235.02"
          y="238.49"
          width="7.55"
          height="2.18"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '238.79500000000002px 239.58px',
          }}
          id="elsqx1dmjrlxh"
          className="animable"
        />
        <rect
          x="252.11"
          y="250.13"
          width="9.66"
          height="2.18"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '256.94px 251.22px',
          }}
          id="el9z1dcpmho4"
          className="animable"
        />
        <rect
          x="285.74"
          y="250.13"
          width="9.66"
          height="2.18"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '290.57px 251.22px',
          }}
          id="elzpvxmcabn7i"
          className="animable"
        />
        <rect
          x="319.37"
          y="250.13"
          width="9.66"
          height="2.18"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '324.2px 251.22px',
          }}
          id="elw0963glv9zf"
          className="animable"
        />
        <rect
          x={353}
          y="250.13"
          width="9.66"
          height="2.18"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '357.83px 251.22px',
          }}
          id="elymaa4k2fwps"
          className="animable"
        />
        <rect
          x="386.63"
          y="250.13"
          width="9.66"
          height="2.18"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '391.46px 251.22px',
          }}
          id="el5atvgbh65n"
          className="animable"
        />
        <rect
          x="420.26"
          y="250.13"
          width="9.66"
          height="2.18"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '425.09px 251.22px',
          }}
          id="el0b4hofnmv1gj"
          className="animable"
        />
        <rect
          x="235.02"
          y="209.42"
          width="7.55"
          height="2.18"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '238.79500000000002px 210.51px',
          }}
          id="elf8l6e5vrgwu"
          className="animable"
        />
        <rect
          x="235.02"
          y="154.7"
          width="7.55"
          height="2.18"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '238.79500000000002px 155.79px',
          }}
          id="elnpvnjhk7gqf"
          className="animable"
        />
        <rect
          x="235.02"
          y="127.2"
          width="7.55"
          height="2.18"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '238.79500000000002px 128.29px',
          }}
          id="eljddui3ri53q"
          className="animable"
        />
        <rect
          x="235.41"
          y="182.06"
          width="7.55"
          height="2.18"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '239.185px 183.15px',
          }}
          id="elurrd65b8z7"
          className="animable"
        />
        <path
          d="M429.65,240.67s-.27,0-.81,0l-2.38,0-9.14.05-33.61.09-110.91.07H246.26v-.26c0-37.09.07-69.73.09-93.11,0-11.68.06-21,.08-27.5,0-3.21,0-5.7,0-7.4,0-.84,0-1.47,0-1.92s0-.65,0-.65,0,.22,0,.65,0,1.08,0,1.92c0,1.7,0,4.19,0,7.4,0,6.46,0,15.82.08,27.5,0,23.38.05,56,.09,93.11l-.26-.26H272.8l110.91.08,33.61.08,9.14.05,2.38,0Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '337.95499420166016px 175.4600067138672px',
          }}
          id="eluye1j6pr2us"
          className="animable"
        />
        <path
          d="M431.78,183.15c0,.14-39.84.26-89,.26s-89-.12-89-.26,39.83-.26,89-.26S431.78,183,431.78,183.15Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '342.7799987792969px 183.14999389648438px',
          }}
          id="elgdtmsuyzd3"
          className="animable"
        />
        <path
          d="M431.78,155.79c0,.14-39.84.26-89,.26s-89-.12-89-.26,39.83-.26,89-.26S431.78,155.65,431.78,155.79Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '342.7799987792969px 155.7899932861328px',
          }}
          id="elhtemypbcbe5"
          className="animable"
        />
        <path
          d="M431.78,128.29c0,.15-39.84.26-89,.26s-89-.11-89-.26,39.83-.26,89-.26S431.78,128.15,431.78,128.29Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '342.7799987792969px 128.2899932861328px',
          }}
          id="el8zetbz2q8l"
          className="animable"
        />
        <path
          d="M431.78,210.51c0,.14-39.84.26-89,.26s-89-.12-89-.26,39.83-.26,89-.26S431.78,210.37,431.78,210.51Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '342.7799987792969px 210.50999450683594px',
          }}
          id="elrhr1ewqj61j"
          className="animable"
        />
        <path
          d="M255.66,234.78V210.51L270.79,187l10.27,7.88,21.07-32.73,12.43,8.75,17.29-30.2,14,11.45L367,112.11l22.7,44.77L408,134.48l21.61-6.19V234.78Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '342.63499450683594px 173.44499969482422px',
          }}
          id="elx2z8syn9v3c"
          className="animable"
        />
        <path
          d="M431.78,119.67a2.79,2.79,0,0,1-.38,0l-1.13,0-4.38,0-16.59.07.11-.06L391.63,143l-.07.08h-.1l-44.5,0,.22-.12-18.71,31.14c-6.37,10.6-12.54,20.85-18.37,30.53l-.19.33-.22-.31-24.12-33.13h.35L264,205.8l-6.11,9.48c-.7,1.08-1.24,1.91-1.62,2.48s-.57.84-.57.84.17-.3.52-.87l1.56-2.51c1.39-2.21,3.42-5.44,6-9.55l21.8-34.37.17-.26.19.25,24.17,33.09-.42,0L328,173.86l18.73-31.14.07-.12H347l44.5.05-.16.08,17.89-23.14,0-.06h.07l16.59.07,4.38,0,1.13,0Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '343.74000549316406px 169.06500244140625px',
          }}
          id="eltmmxgnirgq"
          className="animable"
        />
        <path
          d="M293,179.19a1.71,1.71,0,1,1-1.71-1.64A1.68,1.68,0,0,1,293,179.19Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '291.291396856308px 179.2598865032196px',
          }}
          id="elgeuo2yq11q"
          className="animable"
        />
        <path
          d="M344.36,150a1.71,1.71,0,1,1-1.7-1.64A1.67,1.67,0,0,1,344.36,150Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '342.6513845920563px 150.06987512111664px',
          }}
          id="el8o1v0tdmino"
          className="animable"
        />
        <ellipse
          cx="382.56"
          cy="142.85"
          rx="1.71"
          ry="1.64"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '382.56px 142.85px',
          }}
          id="eltml0bhzl8i"
          className="animable"
        />
        <path
          d="M209.45,75.06a2,2,0,1,1-2-2A2,2,0,0,1,209.45,75.06Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '207.4499969482422px 75.05999755859375px',
          }}
          id="el61lw8xbsiua"
          className="animable"
        />
        <path
          d="M215.21,75.06a2,2,0,1,1-2-2A2,2,0,0,1,215.21,75.06Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '213.2100067138672px 75.05999755859375px',
          }}
          id="el0zoi6z3vog0r"
          className="animable"
        />
        <path
          d="M221,75.06a2,2,0,1,1-2-2A2,2,0,0,1,221,75.06Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '219px 75.05999755859375px',
          }}
          id="el1l1286raxh9"
          className="animable"
        />
        <path
          d="M456.08,82.87c0,.14-57.56.26-128.55.26S199,83,199,82.87s57.55-.26,128.56-.26S456.08,82.72,456.08,82.87Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '327.5399932861328px 82.87000274658203px',
          }}
          id="eluqvr5saef7n"
          className="animable"
        />
      </g>
      <g
        id="freepik--money-box--inject-7"
        style={{ transformOrigin: '159.18314743041992px 378.4860076904297px' }}
        className="animable animator-hidden"
      >
        <path
          d="M39.92,386.57,45.33,406A22.35,22.35,0,0,0,70.39,422h0S80.63,436.6,85,439l3.94,31.13h23.37l1.85-12.61a122.83,122.83,0,0,0,53.15,9.45c29.59-1.57,36.68-10.24,36.68-10.24l3.54,13.4h26.4l4.34-34.28s32.3-28.76,24-62.25c0,0,23.24-15.87,15.36-38.47L272.9,333s-7.49,13.39-15.37,16.15c0,0-21.2-68.16-101-62.64,0,0-26.63-1.18-51.85,10.63,0,0-28-14.57-48.85-3.94,0,0-.39,24,11.42,37.83,0,0-10.24,22.85-11,27.58l-3.05,1.22A22.36,22.36,0,0,0,39.92,386.57Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '159.18315505981445px 378.16099548339844px',
          }}
          id="elvsjkwvjvxus"
          className="animable"
        />
        <path
          d="M96.37,357.29a6.53,6.53,0,1,1-6.53-6.53A6.53,6.53,0,0,1,96.37,357.29Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '89.84000396728516px 357.2900085449219px',
          }}
          id="el11yr4ctr8lp"
          className="animable"
        />
        <g id="elns1l3tq1ets">
          <g
            style={{
              opacity: '0.6000000000000001',
              transformOrigin: '158.72999572753906px 305.0510950088501px',
            }}
            className="animable"
          >
            <path
              d="M126.45,303.81l2.93,8.22s35.51-10.57,58.4,0l3.23-8.22S163.13,290.9,126.45,303.81Z"
              id="elv0x8pj29tri"
              style={{
                transformOrigin: '158.72999572753906px 305.0510950088501px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M193.89,315.8a5.51,5.51,0,0,1-.65-.38c-.42-.27-1.05-.64-1.86-1.11a43.71,43.71,0,0,0-7.23-3.28,55.18,55.18,0,0,0-11.46-2.64,91.73,91.73,0,0,0-14.42-.54A140.74,140.74,0,0,0,143.86,309a58.45,58.45,0,0,0-11.46,2.67,37.61,37.61,0,0,0-7.18,3.36c-1.61,1-2.43,1.61-2.47,1.56a4.32,4.32,0,0,1,.59-.48,18.81,18.81,0,0,1,1.77-1.25,35,35,0,0,1,7.17-3.53,56.25,56.25,0,0,1,11.51-2.8,133.15,133.15,0,0,1,14.47-1.17,89,89,0,0,1,14.49.58,54.51,54.51,0,0,1,11.53,2.77,41.17,41.17,0,0,1,7.2,3.45c.81.5,1.42.91,1.81,1.2A4.73,4.73,0,0,1,193.89,315.8Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '158.31999588012695px 311.9380135536194px',
          }}
          id="el7utvwvp6lkl"
          className="animable"
        />
        <g id="el34up0vqi4ja">
          <g
            style={{
              opacity: '0.2',
              transformOrigin: '52.70096254348755px 385.21575260162354px',
            }}
            className="animable"
          >
            <path
              d="M54.86,377.93a7.29,7.29,0,0,0-1.75-2.69,2.77,2.77,0,0,0-3-.53h0a4.23,4.23,0,0,0-1.5,2.39,23.61,23.61,0,0,0,2.89,17.39,3,3,0,0,0,2,1.42c1.79.31,2.73-1.32,3.17-2.8C58.18,388.12,57,382.69,54.86,377.93Z"
              id="eloopz5jmc2oh"
              style={{
                transformOrigin: '52.70096254348755px 385.21575260162354px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M69.2,394a7.38,7.38,0,0,1,0-1.49,15.45,15.45,0,0,0,0-1.75c0-.68,0-1.46,0-2.32s-.09-1.79-.22-2.79-.29-2.06-.48-3.18a41,41,0,0,0-5.25-13.67c-.61-1-1.16-1.88-1.77-2.68s-1.16-1.56-1.71-2.23-1.07-1.23-1.52-1.74-.86-.93-1.2-1.27a8.43,8.43,0,0,1-1-1.09,8.37,8.37,0,0,1,1.16.95,16.5,16.5,0,0,1,1.27,1.21,21.22,21.22,0,0,1,1.59,1.71c.57.65,1.18,1.37,1.78,2.2s1.2,1.73,1.83,2.69A42.3,42.3,0,0,1,67,375.18a42.84,42.84,0,0,1,2,7.17c.17,1.13.36,2.2.43,3.22s.14,2,.16,2.82,0,1.65,0,2.34a15.77,15.77,0,0,1-.13,1.75A9.52,9.52,0,0,1,69.2,394Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '62.824450969696045px 376.89500427246094px',
          }}
          id="elmw1uove3oij"
          className="animable"
        />
        <path
          d="M76.37,380c-.1,0-.48-1.65-1.59-4.18a31.51,31.51,0,0,0-2.29-4.25A34.91,34.91,0,0,0,68.83,367a34.32,34.32,0,0,0-4.48-3.85,30.81,30.81,0,0,0-4.15-2.46c-2.47-1.21-4.14-1.66-4.1-1.76a4.78,4.78,0,0,1,1.17.27,10.61,10.61,0,0,1,1.35.45,16.88,16.88,0,0,1,1.74.71,28.24,28.24,0,0,1,4.27,2.4,31.75,31.75,0,0,1,4.57,3.88,31.28,31.28,0,0,1,3.69,4.74,27.82,27.82,0,0,1,2.23,4.36c.28.64.46,1.25.64,1.77a11.26,11.26,0,0,1,.38,1.36A4.52,4.52,0,0,1,76.37,380Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '66.23465061187744px 369.4650115966797px',
          }}
          id="elwb9jqie9z3c"
          className="animable"
        />
        <path
          d="M49.16,377a1,1,0,0,1,.34-1,2,2,0,0,1,1.19-.57,2.25,2.25,0,0,1,1.67.52,9.59,9.59,0,0,1,2.25,3.77,26.69,26.69,0,0,1,2,10.45,8.71,8.71,0,0,1-.79,4.32,2.61,2.61,0,0,1-2.6,1.31c-.74-.14-1-.56-.94-.55a2.47,2.47,0,0,0,1,.35,2.42,2.42,0,0,0,2.26-1.3,8.59,8.59,0,0,0,.63-4.13,28.17,28.17,0,0,0-.51-5.23,28.88,28.88,0,0,0-1.44-5.05,9.74,9.74,0,0,0-2.05-3.66,1.88,1.88,0,0,0-2.48-.08A1.61,1.61,0,0,0,49.16,377Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '52.88388419151306px 385.6198921203613px',
          }}
          id="el0mflvf4auj5"
          className="animable"
        />
        <path
          d="M99.42,381.61s.16.19.34.6a6.7,6.7,0,0,1,.44,1.81,7.65,7.65,0,0,1-7.15,8.53,6.6,6.6,0,0,1-1.86-.12c-.43-.1-.65-.19-.65-.23a18.41,18.41,0,0,0,2.47,0,7.65,7.65,0,0,0,6.82-8.13A20.46,20.46,0,0,0,99.42,381.61Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '95.39616632461548px 387.0898218154907px',
          }}
          id="elcrsjn8ky6hw"
          className="animable"
        />
        <path
          d="M95.72,341.35a25.55,25.55,0,0,0-6.44-1.68,24.87,24.87,0,0,0-6.63.58,5.09,5.09,0,0,1,1.86-.72,15.07,15.07,0,0,1,4.81-.38A14.86,14.86,0,0,1,94,340.33,5.4,5.4,0,0,1,95.72,341.35Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '89.18499755859375px 340.2247257232666px',
          }}
          id="elqhgx5m307ye"
          className="animable"
        />
        <path
          d="M205.83,298.2l-.25-.08-.73-.28-2.79-1.11-2-.82c-.74-.29-1.56-.55-2.43-.85-1.76-.58-3.72-1.35-6-1.92l-3.52-1c-1.22-.33-2.52-.57-3.86-.87-2.65-.66-5.55-1.06-8.58-1.56a124.56,124.56,0,0,0-20-1,124,124,0,0,0-19.83,2.47c-3,.71-5.85,1.33-8.45,2.18-1.3.4-2.59.73-3.78,1.16l-3.44,1.24c-2.21.73-4.11,1.64-5.82,2.35-.85.37-1.65.69-2.36,1l-1.94,1-2.7,1.32-.7.33a.75.75,0,0,1-.25.1s.07,0,.22-.14l.68-.38,2.66-1.41,1.92-1c.71-.35,1.51-.69,2.35-1.07,1.7-.73,3.6-1.67,5.81-2.43l3.44-1.27c1.2-.44,2.48-.78,3.79-1.2,2.61-.87,5.47-1.5,8.47-2.23a122.44,122.44,0,0,1,19.91-2.53,123,123,0,0,1,20,1.07c3.05.51,5.95.93,8.62,1.6,1.33.32,2.64.57,3.86.92l3.52,1c2.26.59,4.22,1.39,6,2,.87.31,1.69.59,2.43.88l2,.87,2.75,1.21.71.33C205.76,298.15,205.84,298.19,205.83,298.2Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '156.11542510986328px 295.0057759284973px',
          }}
          id="el42nc2n1li4i"
          className="animable"
        />
        <path
          d="M217.72,304.83a10.76,10.76,0,0,1-3.13-1,10.42,10.42,0,0,1-2.94-1.5,10.92,10.92,0,0,1,3.14,1A10.62,10.62,0,0,1,217.72,304.83Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '214.68499755859375px 303.5799865722656px',
          }}
          id="elo3rsfj87tuk"
          className="animable"
        />
        <path
          d="M51.5,364.91c0,.09-.91.47-2.29,1.34a18.12,18.12,0,0,0-7.56,9.86c-.48,1.56-.6,2.57-.7,2.56a2.11,2.11,0,0,1,0-.72A10.71,10.71,0,0,1,41.3,376,16.28,16.28,0,0,1,49,365.94a10.33,10.33,0,0,1,1.78-.83A2.13,2.13,0,0,1,51.5,364.91Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '46.20953178405762px 371.790030002594px',
          }}
          id="el4n9oy2wozf"
          className="animable"
        />
        <path
          d="M112.93,464.29s-.18-.24-.6-.56a3.07,3.07,0,0,0-2.16-.53,3.78,3.78,0,0,0-2.85,1.82,8.16,8.16,0,0,0-1,4.44l-.46,0a5.51,5.51,0,0,0-1.47-4.34,4.35,4.35,0,0,0-4.77-1,3.38,3.38,0,0,0-2,2.51,3.31,3.31,0,0,0,.73,2.95l-.41.25a12.76,12.76,0,0,0-2.83-5.14,4.47,4.47,0,0,0-4.16-1.3,3.35,3.35,0,0,0-2.17,1.91,4.26,4.26,0,0,0-.22,1.07,1.78,1.78,0,0,1,.07-1.12,3.45,3.45,0,0,1,2.23-2.15,4.77,4.77,0,0,1,4.54,1.28,12.88,12.88,0,0,1,3,5.28l.41,1.12L98,469.9a3.79,3.79,0,0,1-.87-3.39,3.91,3.91,0,0,1,2.33-2.89,4.88,4.88,0,0,1,5.35,1.12,6,6,0,0,1,1.56,4.74l-.46,0a8.33,8.33,0,0,1,1.13-4.64,4.2,4.2,0,0,1,1.47-1.41,4.25,4.25,0,0,1,1.67-.48,3.14,3.14,0,0,1,2.27.69A1.67,1.67,0,0,1,112.93,464.29Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '100.71547603607178px 466.8582878112793px',
          }}
          id="elmm5zg7rpieg"
          className="animable"
        />
      </g>
      <g
        id="freepik--Character--inject-7"
        style={{ transformOrigin: '282.6350402832031px 316.72227478027344px' }}
        className="animable"
      >
        <path
          d="M252.27,462.37l-1.72,7.24S238.7,485,235.05,484.24c-2.4-.49.55-4.5,5-16.19l1-4.82Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '243.23139476776123px 473.31861782073975px',
          }}
          id="el7zh8tad1f8e"
          className="animable"
        />
        <path
          d="M234.57,482a1.46,1.46,0,0,0,.63.61,2.2,2.2,0,0,0,2.27-.32,67.86,67.86,0,0,0,5.89-5.58c2.19-2.3,4-4.52,5.33-6.15l1.51-1.95c.15-.19.29-.36.41-.53a1.22,1.22,0,0,1,.16-.18,1.22,1.22,0,0,1-.16.18l-.38.56c-.33.48-.83,1.16-1.46,2a75.48,75.48,0,0,1-5.3,6.2,58.39,58.39,0,0,1-6,5.57,2.75,2.75,0,0,1-1.34.49,2,2,0,0,1-1.05-.23,1.26,1.26,0,0,1-.5-.46A.67.67,0,0,1,234.57,482Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '242.66799449920654px 475.4016056060791px',
          }}
          id="eltmju1kdiz8"
          className="animable"
        />
        <path
          d="M236.24,477a1.88,1.88,0,0,1,1-.11,5.08,5.08,0,0,1,2.23.77,4.07,4.07,0,0,1,1.62,1.72,2.08,2.08,0,0,1,.26.95s-.11-.36-.39-.88a4.34,4.34,0,0,0-1.6-1.6,5.52,5.52,0,0,0-2.14-.81A9.41,9.41,0,0,0,236.24,477Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '238.7949981689453px 478.5978021621704px',
          }}
          id="elm3ke3wmzyy"
          className="animable"
        />
        <path
          d="M247.46,473.42a1.08,1.08,0,0,1-.15-.35,7.87,7.87,0,0,1-.23-1,5.45,5.45,0,0,1,.55-3.3,5.13,5.13,0,0,1,2.4-2.32,3.47,3.47,0,0,1,1-.3,1.15,1.15,0,0,1,.37,0,8,8,0,0,0-1.29.46,5.25,5.25,0,0,0-2.27,2.29,5.67,5.67,0,0,0-.59,3.18C247.33,472.9,247.49,473.41,247.46,473.42Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '249.21069955825806px 469.7775192260742px',
          }}
          id="el2penvw92cot"
          className="animable"
        />
        <path
          d="M251.52,463.6s-.22,1-.44,2.31a7.93,7.93,0,0,1-.62,2.28s.19-1,.41-2.32A7.5,7.5,0,0,1,251.52,463.6Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '250.9900131225586px 465.89500427246094px',
          }}
          id="eld9i30wnqr8u"
          className="animable"
        />
        <path
          d="M239.89,469.07a2.84,2.84,0,0,1,1.52,0,2.66,2.66,0,0,1,1.37.65c0,.06-.62-.26-1.42-.44S239.9,469.14,239.89,469.07Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '241.33499908447266px 469.3469271659851px',
          }}
          id="elpfegeaig9f7"
          className="animable"
        />
        <path
          d="M239.65,470.31a1.91,1.91,0,0,1,1.28,0,1.81,1.81,0,0,1,1.12.62c0,.05-.51-.26-1.17-.41S239.66,470.38,239.65,470.31Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '240.85000610351562px 470.5674568116665px',
          }}
          id="el7cvdfrd7olo"
          className="animable"
        />
        <path
          d="M238.7,471.87a1.63,1.63,0,0,1,1.33-.17,1.59,1.59,0,0,1,1.12.73,5.14,5.14,0,0,0-1.17-.52A5.21,5.21,0,0,0,238.7,471.87Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '239.92499542236328px 472.029355019331px',
          }}
          id="elwcruym0jidb"
          className="animable"
        />
        <path
          d="M240.71,468.55s.54-.14,1.39-.47a11.37,11.37,0,0,0,1.43-.69c.25-.15.52-.32.78-.5s.51-.44.5-.72-.36-.44-.63-.37a1.72,1.72,0,0,0-.73.49c-.44.41-.81.8-1.11,1.14-.61.68-.94,1.13-1,1.11a1.45,1.45,0,0,1,.2-.34c.14-.21.36-.51.65-.87a15.48,15.48,0,0,1,1.09-1.18,1.86,1.86,0,0,1,.82-.55.69.69,0,0,1,.89.56,1.19,1.19,0,0,1-.58.9,8.2,8.2,0,0,1-.82.5,9,9,0,0,1-1.47.66,8,8,0,0,1-1.05.29C240.85,468.56,240.71,468.57,240.71,468.55Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '242.8499984741211px 467.06394386291504px',
          }}
          id="elsdblag8yq9"
          className="animable"
        />
        <path
          d="M241.33,468.4a13,13,0,0,1-.22-1.32,5.71,5.71,0,0,0-.4-1.37,3,3,0,0,0-.44-.7c-.18-.2-.46-.38-.68-.25s-.25.46-.22.73a3.43,3.43,0,0,0,.23.79,4.8,4.8,0,0,0,.77,1.19c.55.61,1,.9,1,.93s-.12,0-.31-.18a5.45,5.45,0,0,1-.76-.64,4.57,4.57,0,0,1-.84-1.22,3.67,3.67,0,0,1-.26-.85.9.9,0,0,1,.33-.93.78.78,0,0,1,.93.29,3.07,3.07,0,0,1,.47.76,5.3,5.3,0,0,1,.37,1.43c.05.41.07.75.08,1A1.27,1.27,0,0,1,241.33,468.4Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '240.2771841287613px 466.46832883358px',
          }}
          id="elaanjv0z4kse"
          className="animable"
        />
        <path
          d="M309,465.73l.05-9.66L291,455.85,290.75,470l1.12.09c5,.34,25.39,1.36,28.74.39C324.35,469.38,309,465.73,309,465.73Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '305.97357749938965px 463.3689794540405px',
          }}
          id="elt9gs9ix3dfj"
          className="animable"
        />
        <path
          d="M290.5,469.57l.31,0,.9.07,3.28.18c2.78.14,6.62.27,10.86.33s8.08,0,10.86,0l3.29-.09.89,0,.31,0-.31,0H320l-3.29,0c-2.77,0-6.61,0-10.85,0s-8.07-.17-10.85-.26l-3.29-.12-.89,0Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '305.84999084472656px 469.87333339452744px',
          }}
          id="el43755f88vtv"
          className="animable"
        />
        <path
          d="M314.87,470.37a8,8,0,0,1,.63-1.56,7.68,7.68,0,0,1,1.14-1.24,2.38,2.38,0,0,0-1.32,1.12A2.42,2.42,0,0,0,314.87,470.37Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '315.7482276558876px 468.9700164794922px',
          }}
          id="el8riy7ogo9c4"
          className="animable"
        />
        <path
          d="M309.57,467.6c.05,0,.31-.28.57-.69s.45-.77.4-.81-.31.28-.58.69S309.51,467.56,309.57,467.6Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '310.05323231220245px 466.8483098745346px',
          }}
          id="el2uwwkbk3db8"
          className="animable"
        />
        <path
          d="M308.11,466.8c0,.05.33-.14.64-.41s.54-.54.5-.59-.33.15-.64.42S308.07,466.76,308.11,466.8Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '308.6800000667572px 466.3001410961151px',
          }}
          id="elu84qnq981qb"
          className="animable"
        />
        <path
          d="M307.21,465.08a2.16,2.16,0,0,0,.94.14,2.21,2.21,0,0,0,1-.09,2.14,2.14,0,0,0-1-.13A2.2,2.2,0,0,0,307.21,465.08Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '308.17999267578125px 465.1112610697746px',
          }}
          id="el5pznqpi8sqa"
          className="animable"
        />
        <path
          d="M306.9,463.88a2,2,0,0,0,1.05.32,1.81,1.81,0,0,0,1.09-.14A6.18,6.18,0,0,0,308,464,5.67,5.67,0,0,0,306.9,463.88Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '307.969970703125px 464.054738253355px',
          }}
          id="elen6rilfvkm"
          className="animable"
        />
        <path
          d="M310.2,466a3.54,3.54,0,0,0,1.16,0,6,6,0,0,0,1.24-.25,3.22,3.22,0,0,0,.71-.29.62.62,0,0,0,.3-.35.46.46,0,0,0-.17-.47,2.14,2.14,0,0,0-2.65.59,2.05,2.05,0,0,0-.39.77.62.62,0,0,0,0,.31,3.25,3.25,0,0,1,.54-1,2.1,2.1,0,0,1,1-.63,1.77,1.77,0,0,1,1.39.11c.18.14.11.35-.1.47a3,3,0,0,1-.66.27,7.77,7.77,0,0,1-1.2.3C310.64,466,310.2,466,310.2,466Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '311.9109197854996px 465.35981971025467px',
          }}
          id="elqvopodc9rxa"
          className="animable"
        />
        <path
          d="M310.5,466.09a1.13,1.13,0,0,0,.14-.81,1.86,1.86,0,0,0-.3-.85,1.18,1.18,0,0,0-1-.61.48.48,0,0,0-.37.54,1.34,1.34,0,0,0,.19.52,3.56,3.56,0,0,0,.54.71,1.74,1.74,0,0,0,.66.48s-.23-.21-.54-.59a3.7,3.7,0,0,1-.48-.7c-.16-.25-.26-.69,0-.74s.59.27.76.5a1.94,1.94,0,0,1,.32.76A4.9,4.9,0,0,1,310.5,466.09Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '309.8137186765671px 464.9549865722656px',
          }}
          id="elwc6vtm13r9k"
          className="animable"
        />
        <path
          d="M290.94,464.62s.51,0,1.33.06a5.67,5.67,0,0,1,4.69,3.84c.27.78.29,1.3.33,1.3a1.17,1.17,0,0,0,0-.37,4.29,4.29,0,0,0-.18-1,5.49,5.49,0,0,0-4.82-3.94,5.31,5.31,0,0,0-1,0A1,1,0,0,0,290.94,464.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '294.1223487854004px 467.1531753540039px',
          }}
          id="el9m1qxsdgo27"
          className="animable"
        />
        <path
          d="M292.91,457.12a30.18,30.18,0,0,0-.21,3.71,31.64,31.64,0,0,0,0,3.72,31.82,31.82,0,0,0,.2-3.72A32.93,32.93,0,0,0,292.91,457.12Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '292.80136120319366px 460.83497619628906px',
          }}
          id="eltshpn1ohel"
          className="animable"
        />
        <path
          d="M299.61,468.19a10.77,10.77,0,0,0,2.64.29,9.78,9.78,0,0,0,2.65-.18c0-.06-1.19,0-2.64,0S299.62,468.12,299.61,468.19Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '302.25498962402344px 468.3383629024029px',
          }}
          id="eljtvzcs0j02"
          className="animable"
        />
        <path
          d="M296.07,468.14c-.05,0,.09.25.21.52s.18.51.24.51.1-.28,0-.6S296.11,468.09,296.07,468.14Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '296.32024985551834px 468.65049105882645px',
          }}
          id="elhdu8yftz2jm"
          className="animable"
        />
        <path
          d="M294.75,466.46s.07.23.26.42.37.31.41.27-.07-.23-.25-.42S294.8,466.41,294.75,466.46Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '295.0891081094742px 466.8034442663193px',
          }}
          id="el95rppeo19pr"
          className="animable"
        />
        <path
          d="M292.85,465.67c0,.06.25.06.52.16s.45.24.5.2-.1-.29-.43-.41S292.83,465.62,292.85,465.67Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '293.36420452594757px 465.80268646776676px',
          }}
          id="ellakuc72ypf7"
          className="animable"
        />
        <path
          d="M291.49,465.3c0,.05.08.15.23.21s.29.06.31,0-.08-.15-.22-.21S291.52,465.24,291.49,465.3Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '291.761267632246px 465.4049987792969px',
          }}
          id="elny86t47sk7h"
          className="animable"
        />
        <polygon
          points="321.23 280.76 314.29 462.07 286.11 462.66 290.79 305.57 259.11 463.86 232.32 463.86 266.83 281.13 321.23 280.76"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '276.77500915527344px 372.30999755859375px',
          }}
          id="eltsmqnmt8cu"
          className="animable"
        />
        <path
          d="M297.28,287.36a17.8,17.8,0,0,1-.32,3c-.26,1.83-.66,4.37-1.13,7.15a30.79,30.79,0,0,1-.8,3.94,5.62,5.62,0,0,1-1.84,2.77,4.32,4.32,0,0,1-2.05.91,1.65,1.65,0,0,1-.82,0,5.37,5.37,0,0,0,2.64-1.17,5.46,5.46,0,0,0,1.63-2.64,35.24,35.24,0,0,0,.75-3.88c.47-2.79.92-5.31,1.27-7.13A19,19,0,0,1,297.28,287.36Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '293.8000030517578px 296.2708549499512px',
          }}
          id="el6ovdto7a0xf"
          className="animable"
        />
        <path
          d="M291.42,288.23c.06,0-.17.34,0,.81a1,1,0,0,0,.47.61.85.85,0,0,0,1.11-1,.93.93,0,0,0-.54-.54c-.46-.2-.78,0-.81-.07s.26-.41.92-.27a1.27,1.27,0,0,1,.86.72,1.22,1.22,0,0,1-.38,1.35,1.21,1.21,0,0,1-1.38.2,1.26,1.26,0,0,1-.6-.95C291,288.43,291.4,288.17,291.42,288.23Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '292.2804145812988px 288.9539098739624px',
          }}
          id="elwvp2lhp2z3i"
          className="animable"
        />
        <path
          d="M276.29,290.82a5.31,5.31,0,0,1,.54-5c.13.06-.28,1.13-.41,2.5S276.43,290.78,276.29,290.82Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '276.37748539447784px 288.32000732421875px',
          }}
          id="el20b7iir0z91"
          className="animable"
        />
        <path
          d="M279.68,290.6a4.37,4.37,0,0,1-.41-2.66,4.48,4.48,0,0,1,.78-2.59c.13,0-.19,1.19-.28,2.62A25,25,0,0,1,279.68,290.6Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '279.64735493063927px 287.9750061035156px',
          }}
          id="elw7x1ctpiocb"
          className="animable"
        />
        <path
          d="M308.8,291.34a15.44,15.44,0,0,1,.16-2.72,16.79,16.79,0,0,1,.12-2.73,5.09,5.09,0,0,1,.37,2.75A5.17,5.17,0,0,1,308.8,291.34Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '309.14731350541115px 288.614990234375px',
          }}
          id="el8q6kfegknhw"
          className="animable"
        />
        <path
          d="M312.48,291.14c-.14-.06.3-1.25.4-2.77s-.16-2.75,0-2.79a5.88,5.88,0,0,1-.38,5.56Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '312.9285127222538px 288.3600158691406px',
          }}
          id="elyklywuxhef"
          className="animable"
        />
        <path
          d="M282,205.33l17.4-1.39c.11-2,0-9.88,0-9.88s7.24-1.13,7.33-8.36-1.17-23.85-1.17-23.85h0A25.15,25.15,0,0,0,280.22,165l-1.07.83Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '292.94228744506836px 182.55376434326172px',
          }}
          id="elm01z23jasl"
          className="animable"
        />
        <path
          d="M299.34,194a16.74,16.74,0,0,1-9.43-2.68s2.23,5.21,9.45,4.56Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '294.635009765625px 193.628071308136px',
          }}
          id="el9fcrji3ebzq"
          className="animable"
        />
        <path
          d="M302.67,173.19a1,1,0,0,1-1,1,1,1,0,0,1-1.07-.93,1,1,0,0,1,1-1A1,1,0,0,1,302.67,173.19Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '301.63502502441406px 173.22501307725906px',
          }}
          id="el6nrmo9wbmbg"
          className="animable"
        />
        <path
          d="M304.12,172c-.13.13-.91-.45-2-.45s-1.93.56-2.05.43.07-.31.43-.57a2.9,2.9,0,0,1,1.64-.5,2.72,2.72,0,0,1,1.61.52C304.07,171.72,304.18,172,304.12,172Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '302.0848786830902px 171.46447265148163px',
          }}
          id="elerqyhd84oy"
          className="animable"
        />
        <path
          d="M291.44,173.45a1,1,0,0,1-1,1,1,1,0,0,1-1.07-.93,1,1,0,0,1,1-1A1,1,0,0,1,291.44,173.45Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '290.40501403808594px 173.485007584095px',
          }}
          id="elzubxksh085"
          className="animable"
        />
        <path
          d="M293.19,172.23c-.13.14-.91-.44-2-.44s-1.93.56-2.05.42.07-.3.43-.56a2.75,2.75,0,0,1,1.64-.5,2.72,2.72,0,0,1,1.61.52C293.14,171.93,293.26,172.17,293.19,172.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '291.15669345855713px 171.70059204101562px',
          }}
          id="el8muhzt9lg9p"
          className="animable"
        />
        <path
          d="M297.23,180.48a7.65,7.65,0,0,1,1.8-.33c.29,0,.56-.08.6-.28a1.41,1.41,0,0,0-.19-.84q-.39-1-.84-2.16a37.11,37.11,0,0,1-1.88-5.65,37.72,37.72,0,0,1,2.34,5.49c.28.75.54,1.48.8,2.17A1.65,1.65,0,0,1,300,180a.72.72,0,0,1-.47.42,1.79,1.79,0,0,1-.48.07A7.34,7.34,0,0,1,297.23,180.48Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '298.3807212114334px 175.8808765411377px',
          }}
          id="el1tbyozeco1m"
          className="animable"
        />
        <path
          d="M294,181.25c.18,0,.18,1.19,1.21,2.05s2.32.73,2.33.89-.29.24-.83.25a3,3,0,0,1-1.94-.67,2.69,2.69,0,0,1-1-1.73C293.74,181.54,293.87,181.24,294,181.25Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '295.65292036533356px 182.8450847864151px',
          }}
          id="elwt6k7o03vgq"
          className="animable"
        />
        <path
          d="M293.48,167.88c-.11.3-1.22.15-2.52.31s-2.36.52-2.54.24c-.07-.13.11-.41.53-.7a4.43,4.43,0,0,1,3.86-.43C293.29,167.49,293.53,167.73,293.48,167.88Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '290.945885181427px 167.78780657052994px',
          }}
          id="elwdeayo6qbs"
          className="animable"
        />
        <path
          d="M303.71,168.81c-.19.25-1,0-1.88,0s-1.7.17-1.88-.1,0-.38.39-.62a2.56,2.56,0,0,1,1.53-.41,2.67,2.67,0,0,1,1.5.5C303.69,168.42,303.8,168.68,303.71,168.81Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '301.81010222435px 168.29877388477325px',
          }}
          id="elpcvgdtg3ooa"
          className="animable"
        />
        <path
          d="M280,173.34c-.12-.05-5-1.47-4.81,3.48s5.09,3.77,5.1,3.63S280,173.34,280,173.34Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '277.737429857254px 176.89285373687744px',
          }}
          id="elndxhb427k9c"
          className="animable"
        />
        <path
          d="M278.75,178.62s-.08.06-.22.13a.86.86,0,0,1-.65,0,2.13,2.13,0,0,1-1-1.88,2.82,2.82,0,0,1,.2-1.25,1,1,0,0,1,.62-.68.45.45,0,0,1,.52.22c.07.14,0,.24.07.25s.1-.09.06-.29a.59.59,0,0,0-.21-.31.69.69,0,0,0-.48-.11,1.2,1.2,0,0,0-.87.8,2.86,2.86,0,0,0-.26,1.39,2.22,2.22,0,0,0,1.33,2.09.92.92,0,0,0,.78-.15C278.75,178.74,278.77,178.63,278.75,178.62Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '277.6404278278351px 176.85169792175293px',
          }}
          id="elbp3y63048zf"
          className="animable"
        />
        <path
          d="M308.26,155.6a7.65,7.65,0,0,0-11.88-2.29,7.49,7.49,0,0,0-12.31-1.6c-1.39,1.58-2.11,3.71-3.73,5-1.41,1.15-3.31,1.53-4.73,2.66a5.46,5.46,0,0,0,1.95,9.52,5.87,5.87,0,0,0,2.89,8l.72-.3a10.3,10.3,0,0,0,1.5-11.36,2.26,2.26,0,0,0,.26,0,5.76,5.76,0,0,0,7.52-1.72,6.41,6.41,0,0,0,6.9.29,2.64,2.64,0,0,1,1-.47,2.46,2.46,0,0,1,1.29.39,6.08,6.08,0,0,0,3.51.7,3.36,3.36,0,0,0,2.62-1.88h.09a3.88,3.88,0,0,0,2.89-2.8A5.75,5.75,0,0,0,308.26,155.6Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '291.2490577697754px 163.03367042541504px',
          }}
          id="elq2gxpss01um"
          className="animable"
        />
        <path
          d="M319.24,242.44l.64-32.6c-5.79-5.69-8.88-7.39-16.94-8.34l-2.19-.25-.69-5.37-19.76-1.12,1,6.38h0c-2.86.12-5.24,1-7.67,1.47-7.68,1.47-13.21,7.06-14.74,12.23-1.27,4.25-9.38,35.76-9.38,35.76l-1.65,9.51L266,253.53v6.85l0,25.16H321C321.19,279.54,319.24,242.44,319.24,242.44Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '284.4365119934082px 240.15000915527344px',
          }}
          id="elpqzri9u4ssh"
          className="animable"
        />
        <g id="elj1eyg2eb7f">
          <g
            style={{
              opacity: '0.2',
              transformOrigin: '284.4365119934082px 240.15000915527344px',
            }}
            className="animable"
          >
            <path
              d="M319.24,242.44l.64-32.6c-5.79-5.69-8.88-7.39-16.94-8.34l-2.19-.25-.69-5.37-19.76-1.12,1,6.38h0c-2.86.12-5.24,1-7.67,1.47-7.68,1.47-13.21,7.06-14.74,12.23-1.27,4.25-9.38,35.76-9.38,35.76l-1.65,9.51L266,253.53v6.85l0,25.16H321C321.19,279.54,319.24,242.44,319.24,242.44Z"
              id="elkr8tuhib0pr"
              style={{
                transformOrigin: '284.4365119934082px 240.15000915527344px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M256.12,251.05l27.13-3.85,5.16,9.24-25.22,11.37a11,11,0,0,1-4.48,1h0A10.89,10.89,0,0,1,248.64,262l-.82-2Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '268.11499786376953px 258.00499725341797px',
          }}
          id="el8muf9j9bj34"
          className="animable"
        />
        <g id="elpoylwytdfk">
          <g
            style={{
              opacity: '0.2',
              transformOrigin: '268.11499786376953px 258.00499725341797px',
            }}
            className="animable"
          >
            <path
              d="M256.12,251.05l27.13-3.85,5.16,9.24-25.22,11.37a11,11,0,0,1-4.48,1h0A10.89,10.89,0,0,1,248.64,262l-.82-2Z"
              id="el018mw2f63bq9"
              style={{
                transformOrigin: '268.11499786376953px 258.00499725341797px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M311.56,203.49s7.67,2.61,10.89,10c2.1,4.82,5.19,28,5.19,28l3.89,7.51a12.61,12.61,0,0,1,1.42,5.83v1.15a12.65,12.65,0,0,1-2.84,8h0a12.65,12.65,0,0,1-8.7,4.62c-3.89.35-8.59.5-9.59-.64-1.77-2-4.43-7.47-4.43-7.47l11.33-6-4.88-9Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '320.17006492614746px 236.17224884033203px',
          }}
          id="elxcqqnkyf8dn"
          className="animable"
        />
        <g id="elkecltqrlvyb">
          <g
            style={{
              opacity: '0.2',
              transformOrigin: '320.17006492614746px 236.17224884033203px',
            }}
            className="animable"
          >
            <path
              d="M311.56,203.49s7.67,2.61,10.89,10c2.1,4.82,5.19,28,5.19,28l3.89,7.51a12.61,12.61,0,0,1,1.42,5.83v1.15a12.65,12.65,0,0,1-2.84,8h0a12.65,12.65,0,0,1-8.7,4.62c-3.89.35-8.59.5-9.59-.64-1.77-2-4.43-7.47-4.43-7.47l11.33-6-4.88-9Z"
              id="elonmtwlj12je"
              style={{
                transformOrigin: '320.17006492614746px 236.17224884033203px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M265.08,267s.14-.1.44-.25l1.3-.63,4.87-2.28,16.62-7.59-.11.35-3.18-5.7-2-3.54.24.12-19.88,1.95-5.9.53-1.6.12a1.83,1.83,0,0,1-.56,0,3.19,3.19,0,0,1,.55-.1l1.59-.2,5.89-.68L283.23,247h.16l.08.14,2,3.54,3.17,5.7.13.23-.24.11-16.69,7.43-4.93,2.14-1.34.56A2.74,2.74,0,0,1,265.08,267Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '272.0449905395508px 257px',
          }}
          id="elhbss1agn0p"
          className="animable"
        />
        <path
          d="M269.9,248.37c-.14,0-.25-4.85-.25-10.83s.11-10.83.25-10.83.25,4.85.25,10.83S270,248.37,269.9,248.37Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '269.8999938964844px 237.5399932861328px',
          }}
          id="elre03ulz2ql"
          className="animable"
        />
        <path
          d="M316.6,255.62s.29-.09.82-.13a7.68,7.68,0,0,1,2.29.13,2.7,2.7,0,0,1,1.43.82,3.63,3.63,0,0,1,.75,1.72,4,4,0,0,1-.18,2.07,3.86,3.86,0,0,1-1.37,1.76,10.2,10.2,0,0,1-3.93,1.4,18.1,18.1,0,0,1-3.37.33,6.08,6.08,0,0,1-3.05-.53,16.32,16.32,0,0,0,3.05.18,20,20,0,0,0,3.28-.43,10.14,10.14,0,0,0,3.73-1.35,3.43,3.43,0,0,0,1.39-3.35,3.38,3.38,0,0,0-.61-1.54,2.45,2.45,0,0,0-1.21-.74,9.36,9.36,0,0,0-2.2-.28A3.57,3.57,0,0,1,316.6,255.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '315.97093057632446px 259.599404335022px',
          }}
          id="eltzxpd856m"
          className="animable"
        />
        <path
          d="M321.1,268.73a5.65,5.65,0,0,1-2,.23,12.3,12.3,0,0,1-4.69-.77,10.1,10.1,0,0,1-2.33-1.25,5.46,5.46,0,0,1-1.44-1.62,4.29,4.29,0,0,1-.7-1.85c.08,0,.34.68,1,1.66a5.85,5.85,0,0,0,1.42,1.45,10.66,10.66,0,0,0,2.24,1.14,14.28,14.28,0,0,0,4.51.89A14,14,0,0,1,321.1,268.73Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '315.52001953125px 266.2209198474884px',
          }}
          id="el5y9y948yvbd"
          className="animable"
        />
        <path
          d="M326.52,245.23a10.23,10.23,0,0,1-1.34,1.61c-.87.95-2.1,2.25-3.48,3.66s-2.64,2.68-3.58,3.57a8.9,8.9,0,0,1-1.58,1.38,8.67,8.67,0,0,1,1.33-1.62c.87-1,2.1-2.26,3.47-3.67A46.62,46.62,0,0,1,326.52,245.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '321.5299987792969px 250.3400115966797px',
          }}
          id="eld6z1nlbdith"
          className="animable"
        />
        <path
          d="M314.16,240.17a38.25,38.25,0,0,1-.25-6.19,38.43,38.43,0,0,1,.25-6.2,38.43,38.43,0,0,1,.25,6.2A38.25,38.25,0,0,1,314.16,240.17Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '314.16001731157303px 233.97500610351562px',
          }}
          id="el0g6h38wuylp"
          className="animable"
        />
        <path
          d="M318.2,207.69c0,.14-12.21.26-27.27.26s-27.27-.12-27.27-.26,12.21-.26,27.27-.26S318.2,207.54,318.2,207.69Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '290.9300231933594px 207.69000244140625px',
          }}
          id="el8al2coigktq"
          className="animable"
        />
        <path
          d="M300.21,201.44a85.78,85.78,0,0,1-9.41.21,82.54,82.54,0,0,1-9.4-.32,87.2,87.2,0,0,1,9.4-.2A87.18,87.18,0,0,1,300.21,201.44Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '290.80499267578125px 201.3895033299923px',
          }}
          id="eleyekknhaimc"
          className="animable"
        />
        <path
          d="M324.13,218.71c0,.14-14.82.26-33.11.26s-33.12-.12-33.12-.26,14.83-.27,33.12-.27S324.13,218.56,324.13,218.71Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '291.0150146484375px 218.7050018310547px',
          }}
          id="elow813jkgpea"
          className="animable"
        />
        <path
          d="M326.18,230c0,.15-16,.26-35.79.26s-35.79-.11-35.79-.26,16-.26,35.79-.26S326.18,229.89,326.18,230Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '290.3899841308594px 230px',
          }}
          id="eldsswetpsyb"
          className="animable"
        />
        <path
          d="M327.46,241.05c0,.14-16.91.26-37.77.26s-37.77-.12-37.77-.26,16.91-.26,37.77-.26S327.46,240.9,327.46,241.05Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '289.6899948120117px 241.0500030517578px',
          }}
          id="el9zoh4yklivw"
          className="animable"
        />
        <path
          d="M332.57,259c0,.14-18.79.26-42,.26s-42-.12-42-.26,18.79-.26,42-.26S332.57,258.84,332.57,259Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '290.57000732421875px 259px',
          }}
          id="elzqzbnx8qkg"
          className="animable"
        />
        <path
          d="M320.52,271.57c0,.14-12.4.26-27.69.26s-27.69-.12-27.69-.26,12.39-.26,27.69-.26S320.52,271.42,320.52,271.57Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '292.8299865722656px 271.57000732421875px',
          }}
          id="elrf4pp4m4ics"
          className="animable"
        />
        <path
          d="M307.7,242.76l-.59-.44a13.54,13.54,0,0,0-10.68-2.47h0a18.59,18.59,0,0,0-8.31,3.9l-4.65,3.83,4.94,8.86,3.37-4.71s3.14,4.26,3.7,3.81a7.22,7.22,0,0,0,1.23-1.79l-2.24-3.14,5.38,1.12,7.85-3.59-3.37-4.26L307.7,245Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '295.5850524902344px 248.02378463745117px',
          }}
          id="el0zfrnwzgkiz"
          className="animable"
        />
        <polygon
          points="299.41 241.95 282.14 262.86 283.47 264.29 311.49 260.02 325.39 239.11 324.1 237.95 299.41 241.95"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '303.7650146484375px 251.12000274658203px',
          }}
          id="elbiwc77iizun"
          className="animable"
        />
        <path
          d="M317.73,247.47h0a2.66,2.66,0,0,0-2.49,1.7,5.83,5.83,0,0,1-1.7,2.71c-1.25.68-3.4,1.22-4.53.67s-5.66-4.63-6.45-4.18-1.47,1.47-.68,2.38,5,3.62,4.19,4.53-9.63-3.08-11-2.73-2.15,1.18-1.36,1.73,6.79,2.81,7.13,3.6c0,0-9.06-2.38-9.4-1.81s-.9,1.47,0,1.81,8.72,2.38,9.4,2.72a16.47,16.47,0,0,0,3.49,1,37.45,37.45,0,0,1,3.65,1.15,7.92,7.92,0,0,0,5.63-.15l.92-.37a3.6,3.6,0,0,0,2.23-3.55l-.18-3.08,1-2.55Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '304.3416557312012px 255.3325710296631px',
          }}
          id="elxjjcneqq6x"
          className="animable"
        />
        <path
          d="M325.44,239.3a2.18,2.18,0,0,1-.52.13l-1.5.26-5.52.89-8.2,1.25-4.84.73a9.3,9.3,0,0,0-4.69,1.9,30.78,30.78,0,0,0-3.41,3.93c-1.07,1.32-2.09,2.6-3.07,3.82l-5.21,6.45L284.93,263l-1,1.16a2.33,2.33,0,0,1-.37.38s.08-.16.29-.44l.91-1.22,3.42-4.42,5.13-6.53,3-3.84a31.12,31.12,0,0,1,3.48-4,9.77,9.77,0,0,1,4.93-2l4.85-.7,8.22-1.15,5.55-.73,1.51-.17A1.78,1.78,0,0,1,325.44,239.3Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '304.5px 251.91563415527344px',
          }}
          id="elc6jdvtwfs1"
          className="animable"
        />
        <path
          d="M312.33,243.88a2.52,2.52,0,0,0-.78.63.81.81,0,0,0,0,.94.88.88,0,0,0,1.16,0,1.1,1.1,0,0,0,.44-.67.8.8,0,0,0-.23-.75.62.62,0,0,0-.76,0"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '312.28405660390854px 244.77409267425537px',
          }}
          id="el7cvyhx7on79"
          className="animable"
        />
      </g>
      <g
        id="freepik--speech-bubble--inject-7"
        style={{ transformOrigin: '205.77193450927734px 175.27559661865234px' }}
        className="animable"
      >
        <path
          d="M230.53,196.86l-5.08-9a24,24,0,1,0-5.74,6.39h0Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '205.77193450927734px 175.27559280395508px',
          }}
          id="elibrf46jljq"
          className="animable"
        />
        <path
          d="M196.73,172.46c0-2.16,1.3-3.53,3.15-3.53s3.13,1.35,3.13,3.53-1.29,3.54-3.13,3.54S196.73,174.63,196.73,172.46Zm4.47,0c0-1.37-.53-2-1.32-2s-1.32.68-1.32,2,.54,2,1.32,2S201.2,173.84,201.2,172.46Zm6.22-3.39h2.15l-8.64,12.83h-2.15Zm-2.08,9.44c0-2.16,1.3-3.54,3.13-3.54s3.14,1.38,3.14,3.54-1.3,3.54-3.14,3.54S205.34,180.67,205.34,178.51Zm4.45,0c0-1.36-.53-2-1.32-2s-1.32.66-1.32,2,.54,2,1.32,2S209.79,179.87,209.79,178.51Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '204.1699981689453px 175.49000549316406px',
          }}
          id="elwsi8asp8rcl"
          className="animable"
        />
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
          <feColorMatrix
            type="matrix"
            values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
          />
        </filter>
      </defs>
    </svg>
  );
};

export default FeesIcon;

FeesIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
